import { IAcaoEtapa } from "../../../Interfaces/Geral/AcaoEtapa/AcaoEtapaInterfaces";
import {
    AlterarEtapaManualmenteService,
    CadastrarAcaoEtapaService,
    DeletarAcaoEtapaService,
    ListAcoesAcessoUsuarioService,
    ListarAcaoEtapaService,
    ListarAcoesVinculadasDesvinculadasPorGrupoService,
} from "../../../Services/Geral/AcaoEtapa/AcaoEtapaService";
import { Controller } from "../../Controller";

export const ListarAcaoEtapaController = (ID_ETAPA: number, idCaso?: number) =>
    Controller(ListarAcaoEtapaService(ID_ETAPA, idCaso));

export const CadastrarAcaoEtapaController = (data: IAcaoEtapa) =>
    Controller(CadastrarAcaoEtapaService(data));

export const DeletarAcaoEtapaController = (
    ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
) =>
    Controller(
        DeletarAcaoEtapaService(ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO)
    );

export async function AlterarEtapaManualmenteController(
    idCaso: number,
    novaEtapa: number,
    justificativa: string
) {
    return Controller(
        AlterarEtapaManualmenteService(idCaso, novaEtapa, justificativa)
    );
}

export const ListarAcoesVinculadasDesvinculadasPorGrupoController = (
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number,
    ID_GRUPO: number
) =>
    Controller(
        ListarAcoesVinculadasDesvinculadasPorGrupoService(
            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
            ID_GRUPO
        )
    );

export const ListAcoesAcessoUsuarioController = (
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
) =>
    Controller(
        ListAcoesAcessoUsuarioService(ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO)
    );
